(function () {
  "use strict";

  // COTAÇÃO ATUAL (DOLAR E EURO)
  $.ajax({
    url: "https://economia.awesomeapi.com.br/all/USD-BRL,EUR-BRL",
    type: "get",
    async: true,
    success: function (data) {
      setTimeout(() => {
        // DOLAR
        $(".dolar-bid").html(formataMoeda(data.USD.bid, 2, null, null));
        if (data.USD.varBid[0] == "-") {
          $(".dolar-bid-variable").addClass("down-money");
          $(".dolar-bid-variable-icon").addClass("fas fa-long-arrow-alt-down");
        } else {
          $(".dolar-bid-variable").addClass("up-money");
          $(".dolar-bid-variable-icon").addClass("fas fa-long-arrow-alt-up");
        }

        // EURO
        $(".euro-bid").html(formataMoeda(data.EUR.bid, 2, null, null));
        if (data.EUR.varBid[0] == "-") {
          $(".euro-bid-variable").addClass("down-money");
          $(".euro-bid-variable-icon").addClass("fas fa-long-arrow-alt-down");
        } else {
          $(".euro-bid-variable").addClass("up-money");
          $(".euro-bid-variable-icon").addClass("fas fa-long-arrow-alt-up");
        }

        $(".header-infos").removeClass("loading-infos-header");
        $(".header-infos").addClass("show-infos-header");
      }, 2000);
    },
    error: function (xhr, type, exception) {
      $(".header-infos").removeClass("loading-infos-header");
      $(".header-infos").addClass("hide-infos-header");
    },
  });

  // CLIMA E TEMPO
  let estado_origem_ip = sessionStorage.getItem("estado_origem_ip");
  if (!estado_origem_ip) {
    $.ajax({
      url: url_base + "acoes/api/dados_localizacao_ip.php",
      success: function (data) {
        if (data != "erro") {
          sessionStorage.setItem("estado_origem_ip", data);
          geraMapaClima();
        }
      },
    });
  } else {
    geraMapaClima();
  }

  function geraMapaClima() {
    estado_origem_ip = sessionStorage.getItem("estado_origem_ip");
    $.ajax({
      url: "https://apiprevmet3.inmet.gov.br/previsao/capitais",
      type: "get",
      async: true,
      dataType: "json",
      success: function (data) {
        console.log(estado_origem_ip);
        setTimeout(() => {
          if (estado_origem_ip == "Belem") {
            estado_origem_ip = "Belém";
          }
          if (estado_origem_ip == "Brasilia") {
            estado_origem_ip = "Brasília";
          }
          if (estado_origem_ip == "Cuiaba") {
            estado_origem_ip = "Cuiabá";
          }
          if (estado_origem_ip == "Florianopolis") {
            estado_origem_ip = "Florianópolis";
          }
          if (estado_origem_ip == "Goiania") {
            estado_origem_ip = "Goiânia";
          }
          if (estado_origem_ip == "Joao Pessoa") {
            estado_origem_ip = "João Pessoa";
          }
          if (estado_origem_ip == "Macapa") {
            estado_origem_ip = "Macapá";
          }
          if (estado_origem_ip == "Maceio") {
            estado_origem_ip = "Maceió";
          }
          if (estado_origem_ip == "Sao Luis") {
            estado_origem_ip = "São Luís";
          }
          if (estado_origem_ip == "Sao Paulo") {
            estado_origem_ip = "São Paulo";
          }
          if (estado_origem_ip == "Vitoria") {
            estado_origem_ip = "Vitória";
          }
          let previsao =
            data[estado_origem_ip][$("#data-atual").data("data")]["tarde"];
          //console.log(previsao);
          $("#estado-previsao").html(estado_origem_ip);
          $("#imagem-previsao").attr("src", previsao.icone);
          $("#imagem-previsao").attr("alt", previsao.resumo);
          $("#imagem-previsao").attr("title", previsao.resumo);
          $(".header-clima").attr("title", previsao.resumo);
          $(".clima-grau-minima").html(previsao.temp_min + "°C");
          $(".clima-grau-maxima").html(previsao.temp_max + "°C");
          $(".header-clima").removeClass("loading-infos-header");
          $(".header-clima").addClass("show-infos-header");
        }, 0);
      },
      error: function (xhr, type, exception) {
        $(".header-clima").removeClass("loading-infos-header");
        $(".header-clima").addClass("hide-infos-header");
      },
    });
  }
})();
